import requests from '@tools/requests';
import { URL_DEALUDUR_MARKER_CREATE, URL_DEALUDUR_MARKER_REMOVE } from '@tools/routes/routes';
import { flashBagError } from '@tools/flashbag';
import Logger from '@tools/logger/logger';
import type { DealUdurMarker } from '@models/dealUdurMarker.ts';

export const createDealUdurMarker = async (dealUdurMarker: DealUdurMarker): Promise<boolean> => {
  try {
    await requests.post(URL_DEALUDUR_MARKER_CREATE, {
      marker: dealUdurMarker,
    });

    return true;
  } catch (error: unknown) {
    flashBagError();
    Logger.error(error);
  }

  return false;
};

export const deleteDealUdurMarker = async (): Promise<boolean> => {
  try {
    await requests.delete(URL_DEALUDUR_MARKER_REMOVE);

    return true;
  } catch (error: unknown) {
    flashBagError();
    Logger.error(error);
  }

  return false;
};
